import Storage from "@/helpers/storage";

export default {
  state: {
    options: {}
  },

  mutations: {
    setOptions(state, options) {
      if (!options.primaryColour || options.primaryColour === "") {
        options.primaryColour = "#4990E2";
      }

      if (!options.primaryColour || options.textColour === "") {
        options.textColour = "#FFFFFF";
      }

      // Persist uid to localStorage for conversation continuity across page reloads
      if (options.uid) {
        Storage.setItem("widgetUid", options.uid);
      } else {
        // Reuse persisted uid if available
        const persistedUid = Storage.getItem("widgetUid");
        if (persistedUid) {
          options.uid = persistedUid;
        }
      }

      state.options = options;
    },
    setCampaign(state, campaign) {
      const params = new URLSearchParams(location.search);
      if (params.get(campaign + "_id")) {
        state.options.context.campaign_id = params.get(campaign + "_id");
      }
      if (params.get(campaign + "_name")) {
        state.options.context.campaign_name = params.get(campaign + "_name");
      }
      if (params.get(campaign + "_campaign")) {
        state.options.context.campaign_name = params.get(campaign + "_name");
      }
      if (params.get(campaign + "_source")) {
        state.options.context.campaign_source = params.get(campaign + "_source");
      }
      if (params.get(campaign + "_medium")) {
        state.options.context.campaign_medium = params.get(campaign + "_medium");
      }
      if (params.get(campaign + "_term")) {
        state.options.context.campaign_term = params.get(campaign + "_term");
      }
      if (params.get(campaign + "_content")) {
        state.options.context.campaign_content = params.get(campaign + "_content");
      }
      state.options.context.cookies = Object.fromEntries(document.cookie.split('; ').filter(k => k.startsWith('_ga')).map(x => x.split('=')));
    },
    setCookies(state) {
      state.options.context.cookies = Object.fromEntries(document.cookie.split('; ').filter(k => k.startsWith('_ga')).map(x => x.split('=')));
    }
  },

  actions: {
    setOptions({commit}, options) {
      commit("setOptions", options);
    },
    setCampaign({commit}, name) {
      commit("setCampaign", name);
    },
    setCookies({commit}) {
      commit("setCookies");
    }
  }
};
